import { ReportRouteProps } from '../Router/Router'
import { connect } from 'react-redux'
import { AddReportComponent, Fields } from './AddReport'
import { addReport } from './actions/AddReport'
import { withRouter } from 'react-router'
import { RootState } from '../../reducers/root-reducer'
import SiteConfig from '../../model/SiteConfig'

const mapStateToProps = (state: RootState, ownProps: ReportRouteProps): Fields => {
  const markets = state.report.reportGroups
  const reportGroups = markets && markets[ownProps.match.params.market]
  return {
    reportGroup:
      reportGroups && reportGroups.find(r => r.key === ownProps.match.params.reportGroup),
    reportGroupsLoading: state.report.reportGroupsLoading,
    sites: state.siteConfig.markets.has(ownProps.match.params.market) ? state.siteConfig.markets.get(ownProps.match.params.market)!.siteConfigs.filter(
      (site: SiteConfig) =>
        site.marketKey.toLowerCase() === ownProps.match.params.market.toLowerCase() &&
        site.reportGroups.find(rg => rg.key === ownProps.match.params.reportGroup)
    ) : [],
    sitesLoading: state.siteConfig.markets.has(ownProps.match.params.market) ? state.siteConfig.markets.get(ownProps.match.params.market)!.sitesLoading : true,
    markets: state.market.markets,
    marketsLoading: state.market.marketsLoading
  }
}

// const mapDispatchToProps = { onSubmit: (market: string, reportGroup: string, report: NewReport) => addReport(market, reportGroup, report) }
const mapDispatchToProps = { onSubmit: addReport }

export const AddReportContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddReportComponent)
)
